<!-- Ссылка на карточку пользователя с компактным аватаром -->
<template>
  <BaseEntityLink
    route-name="UserDetails"
    :entity-id="user.id"
    :title="displayName"
    :new-tab="newTab"
  >
    <template #icon>
      <span class="user-entity-link__avatar" :style="{ background: avatarColor }">
        {{ avatarInitials }}
      </span>
    </template>
  </BaseEntityLink>
</template>

<script>
import { useCompanyUserStore } from "@/stores/companyUserStore";
import { formatUserInitials } from "@/utils/user/identityUtils";

export default {
  name: "UserEntityLink",

  props: {
    user: {
      type: Object,
      required: true,
    },
    newTab: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    displayName() {
      return (
        this.user.initials ||
        this.user.full_name ||
        this.user.name ||
        `Пользователь #${this.user.id}`
      );
    },

    avatarInitials() {
      return formatUserInitials(this.displayName);
    },

    avatarColor() {
      return useCompanyUserStore().getUserColor(this.user.id);
    },
  },
};
</script>

<style scoped>
.user-entity-link__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 50%;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}
</style>
